export default {"src":"/_next/static/media/1.1.3c29e6ad.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};